import React from "react";
import {useRoutes} from "react-router-dom";
import Page404 from "../pages/Page404";
import Home from "../pages/Home";

const Router = () => {
    const routes = [
        {
            path: '/',
            element: <Home />
        },
        {
            path: '*',
            element: <Page404/>
        }
    ];

    return useRoutes(routes);
}

export default Router
